import styled from "styled-components"

export const Main = styled.div`
  display: flex;
  width: 320px;
  height: 235.65px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const AgentDataBox = styled.div`
  height: 70px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const AgentImageBox = styled.div`
  height: 154px;
  width: 154px;
  border-radius: 100%;
  background: linear-gradient(180deg, #eae69c 0%, #b6872d 100%);

  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.15s;
  cursor: pointer;

  &:hover {
    box-shadow: 0px 0px 20px 5px #bb913c;
    transition: all 0.15s;
  }

  img {
    pointer-events: none;
    height: 150px;
    width: 150px;
    border-radius: 100%;
  }
`

export const Name = styled.p`
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 2.7rem;
  letter-spacing: 0.05em;
  color: #fdfdfd;
`

export const Phone = styled.p`
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2.1rem;
  letter-spacing: 0.05em;
  color: #fdfdfd;
  
  a {
    background: linear-gradient(
            90deg,
            #ce9638 5.35%,
            #eae69c 17.05%,
            #b6872d 114.34%
    );
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
    letter-spacing: 0.05em;
    color: #fdfdfd;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }


`

export const Email = styled.p`
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2.1rem;
  letter-spacing: 0.05em;
  color: #fdfdfd;
`

export const UASpan = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  p {
    font-size: 1.05rem;
    font-weight: 600;
    line-height: 1.5rem;
    letter-spacing: 0.05em;
    color: #fdfdfd;
  }

  img {
    width: 14px;
    height: 10px;
  }
`
